import { useState } from "react";
import { Plus, Stamp, FileText, Plane, Hotel, Shield, IdCard } from "lucide-react";
import MspShell from "../../components/msp/MspShell";

const TABS = ["All", "Passport", "Visas", "Tickets", "Insurance"];
const DOCS = [
  { id: "p1", label: "Passport",             sub: "Thomas V. · Exp: Jun 12, 2030",     Icon: IdCard, hue: "bg-blue-50 text-blue-600" },
  { id: "p2", label: "Visa - Japan",         sub: "Approved · Exp: Apr 10, 2027",       Icon: Stamp,  hue: "bg-emerald-50 text-emerald-600" },
  { id: "p3", label: "Flight Tickets",       sub: "SEA → NRT · AS123",                  Icon: Plane,  hue: "bg-sky-50 text-sky-600" },
  { id: "p4", label: "Hotel Reservations",   sub: "4 bookings · Mar 27 – Apr 5, 2027",  Icon: Hotel,  hue: "bg-fuchsia-50 text-fuchsia-600" },
  { id: "p5", label: "Travel Insurance",     sub: "Policy #TI-45872",                    Icon: Shield, hue: "bg-rose-50 text-rose-600" },
  { id: "p6", label: "COVID / Health Docs",  sub: "Vaccination Certificate",             Icon: FileText, hue: "bg-amber-50 text-amber-600" },
  { id: "p7", label: "Driver's License",     sub: "Exp: Dec 5, 2088",                    Icon: IdCard, hue: "bg-violet-50 text-violet-600" },
];

export default function MspDocuments() {
  const [t, setT] = useState("All");
  return (
    <MspShell title="Documents" testid="msp-documents">
      <div className="flex gap-2 overflow-x-auto scrollbar-none" style={{ scrollbarWidth: "none" }} data-testid="msp-docs-tabs">
        {TABS.map((x) => (
          <button key={x} onClick={() => setT(x)} data-testid={`msp-docs-tab-${x.toLowerCase()}`}
            className={`shrink-0 px-4 py-1.5 rounded-full text-sm font-700 border ${t === x ? "bg-blue-600 text-white border-blue-600" : "bg-white text-slate-600 border-slate-200"}`}>
            {x}
          </button>
        ))}
      </div>

      <div className="space-y-3" data-testid="msp-docs-list">
        {DOCS.map(({ id, label, sub, Icon, hue }) => (
          <div key={id} data-testid={`msp-doc-${id}`}
            className="flex items-center gap-3 bg-white rounded-2xl border border-slate-200 p-3.5 shadow-sm">
            <span className={`w-11 h-11 rounded-xl grid place-items-center ${hue}`}><Icon className="w-5 h-5" /></span>
            <div className="flex-1 min-w-0">
              <div className="font-700 text-slate-900 truncate">{label}</div>
              <div className="text-xs text-slate-500 mt-0.5 truncate">{sub}</div>
            </div>
            <button className="text-slate-400 hover:text-blue-600 text-xl font-800 px-2" aria-label="Open">›</button>
          </div>
        ))}
      </div>

      <button data-testid="msp-doc-add"
        className="w-full inline-flex items-center justify-center gap-2 rounded-2xl bg-blue-600 text-white py-3.5 font-700 hover:brightness-110">
        <Plus className="w-4 h-4" /> Add Document
      </button>
    </MspShell>
  );
}
